var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPencilSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M19.49 2.839a1.4 1.4 0 0 0-1.98 0L15.848 4.5 19.5 8.152 21.16 6.49a1.4 1.4 0 0 0 0-1.98zM18.65 9 15 5.349l-10.4 10.4a.4.4 0 0 0-.1.165l-1.593 5.18 5.18-1.594a.4.4 0 0 0 .164-.1zm-1.99-7.01a2.6 2.6 0 0 1 3.677 0l1.672 1.672a2.6 2.6 0 0 1 0 3.677L9.1 20.249a1.6 1.6 0 0 1-.661.398l-6.263 1.927a.6.6 0 0 1-.75-.75l1.927-6.263a1.6 1.6 0 0 1 .398-.66z",
  clipRule: "evenodd"
})));
export { SvgIconPencilSmall as ReactComponent };